module.exports = __webpack_public_path__ + "img/thumbnail_HoneyBadger_m_normal.566a2191.png";